import './HeaderStyles.css'
export function TodoHeader({ children }) {
	return <header className='TodoHead'>{children}</header>
}
